<template>
    <v-card>
        <v-card-text>
            <v-tabs v-model="tab" grow>
                <v-tab>daftar</v-tab>
                <v-tab>masuk</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <signup-form @submit="signup" class="pa-4"></signup-form>
                </v-tab-item>

                <v-tab-item>
                    <login-form @submit="login" class="pa-4"></login-form>
                </v-tab-item>
            </v-tabs-items>
        </v-card-text>
    </v-card>
</template>

<script>
import { sync } from 'vuex-pathify'
import JoinMixin from '../mixins/JoinMixin'
import LoginForm from '@/components/auth/LoginForm'
import SignupForm from '@/components/auth/SignupForm'

export default {
    mixins: [JoinMixin],

    props: {
        period: {
            type: Object,
            required: true
        }
    },

    components: {
        LoginForm,
        SignupForm,
    },

    data() {
        return {
            tab: 0,
        }
    },

    computed: {
        ...sync('home', ['credential', 'loginPassword', 'error']),
    },

    methods: {
        signup() {
            this.$store.set('home/period', this.period)
            const data = {
                ...this.$store.get('home/signupData')
            }

            this.$emit('signup', data)
        },

        async login() {
            try {
                await this.$store.dispatch('auth/login', {
                    data: {
                        credential: this.credential,
                        password: this.loginPassword
                    },
                    noErrorRedirection: true
                })
                const response = await this.$api.get('auth')

                this.$store.dispatch('auth/setDataFromAuth', response.data)
                this.$emit('login')
            } catch (e) {
                if (e?.response.status == 401) {
                    this.error = true
                    return
                }

                throw e
            }
        }
    }
}
</script>
